var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReceptionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 10H1.66666",
    stroke: "#006838",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 14.1667H13.3333C11.762 14.1667 10.9763 14.1667 10.4882 13.6785C10 13.1903 10 12.4047 10 10.8333V10",
    stroke: "#006838",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33334 10V18.3333M16.6667 10V18.3333",
    stroke: "#006838",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83334 4.99996V4.16663C5.83334 2.98812 5.83334 2.39886 6.19946 2.03274C6.56558 1.66663 7.15484 1.66663 8.33334 1.66663H11.6667C12.8452 1.66663 13.4344 1.66663 13.8006 2.03274C14.1667 2.39886 14.1667 2.98812 14.1667 4.16663V4.99996C14.1667 6.17847 14.1667 6.76773 13.8006 7.13384C13.4344 7.49996 12.8452 7.49996 11.6667 7.49996H8.33334C7.15484 7.49996 6.56558 7.49996 6.19946 7.13384C5.83334 6.76773 5.83334 6.17847 5.83334 4.99996Z",
    stroke: "#006838",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 7.5L11.6667 10M8.75001 7.5L8.33334 10",
    stroke: "#006838",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceptionIcon);
export default __webpack_public_path__ + "static/media/ReceptionIcon.d321d98172f95da5247a1634512667fb.svg";
export { ForwardRef as ReactComponent };